import type { FC } from 'react';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';
import { cn } from '@src/design-system/helpers';
import HostItem from './components/host-item';

const BasicInformation: FC<{
  host: TPlacementHostCompany;
  modal?: boolean;
}> = ({ host, modal = true }) => {
  const organizationName =
    typeof host.organization === 'object' ? host.organization.name : '—';

  return (
    <div
      className={cn(
        'space-y-4 p-4 m-4 mt-0 bg-white rounded-xl',
        !modal && 'm-0 p-0 pt-4'
      )}
    >
      <p className='font-semibold text-gray-800'>Basic Information</p>
      <div
        className={cn(
          'flex flex-col gap-4',
          !modal && 'flex-row items-start space-x-12 gap-y-0'
        )}
      >
        <HostItem label='Organization' value={organizationName} />
        <HostItem
          label='Description'
          value={host.description?.trim() ? host.description : '—'}
        />
      </div>
    </div>
  );
};

export default BasicInformation;
